import { Injectable } from '@angular/core';

import { Action, State, StateContext } from '@ngxs/store';
import { catchError, tap } from 'rxjs/operators';

import { BcStateContext } from '@bayclubs/state';
import { FeaturesModel, FeaturesService } from '@bayclubs/employee-management-api';

import * as actions from './features.actions';
import { FeaturesStateModel, FEATURES_FEATURE_KEY } from './features.state.model';


@Injectable({ providedIn: 'root' })
@State<FeaturesStateModel>({
    name: FEATURES_FEATURE_KEY,
    defaults: {
        features: BcStateContext.Empty<FeaturesModel>()
    }
})
export class FeaturesState {
    constructor(
        private featuresService : FeaturesService
    ) { }

    @Action(actions.LoadFeaturesAction)
    loadFeatures(ctx: StateContext<FeaturesStateModel>) {
        return this.featuresService.api10FeaturesGet().pipe(
            tap(response => {
                ctx.dispatch(new actions.LoadFeaturesSuccessAction(response));
            }),
            catchError(error => {
                ctx.patchState({
                    features: BcStateContext.Error(),
                });
                throw error;
            })
        );
    }

    @Action(actions.LoadFeaturesSuccessAction)
    loadFeaturesSuccess(ctx: StateContext<FeaturesStateModel>, action: actions.LoadFeaturesSuccessAction) {
        return ctx.patchState({
            features: BcStateContext.Loaded(action.features)
        });
    }

}
